module.exports = __webpack_public_path__ + "static/media/billValue.8c8f211f.svg";